import { Button } from "antd";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CustomIcon, Widget, WidgetLoader } from "datastake-daf/dist/components";
import OverviewWidget from "../../components/OverviewWidget";

export default function Partners({
  mod,
  loading,
  data = {},
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const config = useMemo(() => [
    { label: t('Information Sources'), value: data.sources, },
    { label: t('Information Clients'), value: data.clients, },
  ], [data, t]);

  return (
    <Widget
      title={t('Partners')}
      className="with-border-header custom-width-b h-w-btn-header"
      addedHeader={(
        <>
          <div className="flex-1" />
          <Button type="primary" onClick={() => navigate(`/app/${mod}/information-channels`)}>
            <CustomIcon name="ArrowUpRight" width={20} height={20} color="white" />
          </Button>
        </>
      )}
    >
      {!!loading && <WidgetLoader background="white" />}
      <OverviewWidget config={config} />
    </Widget>
  )
}
